module.exports = __webpack_public_path__ + "static/img/admin.7cc7a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin.png
// module id = MCVb
// module chunks = 1